// contexto de permisos de administrador

import React, { createContext, useState } from 'react'

// Define the shape of the context value
interface LoadingContextType {
  isLoading: boolean
  setIsLoading: React.Dispatch<React.SetStateAction<boolean >>
}
// Create the context
export const LoadingContext = createContext<LoadingContextType>({
  isLoading: false,
  setIsLoading: () => {}
})

// Create a provider component
export const LoadingProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean >(false)
  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}
